// src/components/TZMMS-INV/components/InventorySummary.jsx
// ============================================================================
// TZMMS Inventory Counter — render-only summary card
// ----------------------------------------------------------------------------
// PURPOSE
// - Show the most important page status without pushing logic into the page.
// - Keep this component display-only for easy editing later.
// ============================================================================

import React from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function InventorySummary({ count, recipient, lastScannedValue }) {
  // ============================================================================
  // BLOCK TZI.SUM.001 — Derived display text
  // ============================================================================
  const countLabel = `${count} Item${count === 1 ? '' : 's'}`; // Natural singular/plural text.
  const safeRecipient = recipient || '(missing user email)'; // Warn when the page cannot email anyone.
  const safeLastValue = lastScannedValue || 'No scans yet'; // Blank-state summary text.

  // ============================================================================
  // BLOCK TZI.SUM.002 — Render
  // ============================================================================
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={{ xs: 1, md: 1.25 }}>
          <Typography variant="h6">Session Summary</Typography>

          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Chip label={countLabel} color="primary" size="small" />
            <Chip label={`Recipient: ${safeRecipient}`} variant="outlined" size="small" />
          </Stack>

          <Typography variant="body2" color="text.secondary">
            Last Scan
          </Typography>

          <Typography
            variant="body1"
            sx={{
              wordBreak: 'break-word',
              fontFamily: 'monospace',
              fontSize: { xs: '0.875rem', md: '1rem' },
            }}
          >
            {safeLastValue}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
